import styled from "styled-components";
import { size } from "styled-theme";
import { mobileBreakPoint } from "./constants";
import LogoImage from "@theme/assets/nimble-logo.svg";
import React from "react";

const NimbleLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  
  .finance {
    @media only screen and (max-width: ${size(mobileBreakPoint)}) {
      display: none;
    }
  }
`;

export const NimbleLogo = ({onClick}) => (
  <NimbleLogoWrapper onClick={onClick}>
    <img src={LogoImage} alt="logo" width="105px" />
  </NimbleLogoWrapper>
);